import {config} from "../environment";

export async function trekkHustandOgAlleAktivePrissoknader(): Promise<void> {
  return fetch(`${config.apiUrl}/api/avsluttsoknad`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then((res) => {
    if (!res.ok) {
      throw new Error(`Server error: ${res.status}`);
    }
  });
}
